import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { LuMoveRight } from "react-icons/lu";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { Autoplay, Navigation } from "swiper/modules";

function Banner() {
  const sliders = [
    {
      img: require("../../assets/banners-3/Home-Page-1.jpg"),
      link: "/vehicles/victoris",
    },
    {
      img: require("../../assets/banners-3/Banners-Home-Page-2.jpg"),
      link: "/book-a-service",
    },
    {
      img: require("../../assets/banners/Banners_MDS.webp"),
      link: "/driving-school",
    },
    {
      img: require("../../assets/Banners_Insurance.jpg"),
      link: "/insurance",
    },
  ];

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  return (
    <Swiper
      spaceBetween={30}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      navigation={{
        nextEl: navigationNextRef.current,
        prevEl: navigationPrevRef.current,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
      }}
      loop={true}
      modules={[Autoplay, Navigation]}
      className="mySwiper slider-home"
    >
      {sliders.map((item, i) => (
        <SwiperSlide key={i}>
          <Link to={item.link}>
            <img
              src={item.img}
              loading="lazy"
              className="
              w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]

              object-cover  object-center
            "
              alt={`banner-${i}`}
              fill
            />
          </Link>
        </SwiperSlide>
      ))}

      {/* PREV BUTTON */}
      <div
        ref={navigationPrevRef}
        className="absolute z-10 p-1 -translate-y-1/2 bg-white rounded-full cursor-pointer left-3 sm:left-10 top-1/2 sm:p-3"
      >
        <LuMoveRight className="rotate-180" />
      </div>

      {/* NEXT BUTTON */}
      <div
        ref={navigationNextRef}
        className="absolute z-10 p-1 -translate-y-1/2 bg-white rounded-full cursor-pointer right-3 sm:right-10 top-1/2 sm:p-3"
      >
        <LuMoveRight />
      </div>
    </Swiper>
  );
}

export default Banner;
